module.exports = __webpack_public_path__ + "static/media/arrowRight.e8391da8.svg";